import URI from 'urijs';

export const isLocal = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname.indexOf('ads.microsoft.com') === -1 &&
    hostname.indexOf('ads-int.microsoft.com') === -1;
};

export const shouldEmulateNoStores = () => {
  if (!isLocal()) return false;

  const currentURL = URI(window.location.href);
  const noStores = currentURL.hasQuery('noStores', 'true');
  return noStores;
};

